import { Pipe, PipeTransform } from '@angular/core';
import { LgvTSHelper } from '../utility/ts-helper';


@Pipe({
    name: 'LgvPhoneNumber'
})
export class LgvPhoneNumberPipe implements PipeTransform {

    transform(strPhone: string) {
        return LgvTSHelper.formattedPhoneNumber(strPhone, true);
    }
}
